var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"w100 h100 draw-image",attrs:{"src":_vm.src,"alt":"无法加载","data-unique-id":_vm.uniqueId},on:{"mousedown":_setup.handleImageDown,"mouseup":_setup.handleImageUp}})
}
var staticRenderFns = []

export { render, staticRenderFns }